import * as ActionTypes from '../constants/action_types'
import * as utils from './utils'
//import * as f from '../classes/Filters'
import { PlanFilters } from '../classes/FilterHelpers'

// -----------------------------------------------------------------------------
// API Calls

function fetchHomepage (groupName) {
  return utils.makeApiCall({
    url: `/api/groups/${groupName}`,
    actionRequest: ActionTypes.REQUEST_HOMEPAGE,
    actionReceive: ActionTypes.RECEIVE_HOMEPAGE,
    actionFailure: ActionTypes.REQUEST_HOMEPAGE_FAILURE,
    authenticated: true,
    actionProps: {
      groupName: groupName
    }
  })
}

function fetchHomepageTopicDetails (topicId) {
  return utils.makeApiCall({
    url: `/api/topics/${topicId}/details`,
    actionRequest: ActionTypes.REQUEST_HOMEPAGE_TOPIC_DETAILS,
    actionReceive: ActionTypes.RECEIVE_HOMEPAGE_TOPIC_DETAILS,
    actionFailure: ActionTypes.REQUEST_HOMEPAGE_TOPIC_DETAILS_FAILURE,
    authenticated: true,
    actionProps: {
      topicId: topicId
    }
  })
}

function fetchHomepageTopicPlan (topicId) {
  const body = {
    page: 1,
    filters: PlanFilters.Anticipation,
    homepage: true
  }
  return utils.makeApiCall({
    url: `/api/topics/${topicId}/plan`,
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_HOMEPAGE_TOPIC_PLAN,
    actionReceive: ActionTypes.RECEIVE_HOMEPAGE_TOPIC_PLAN,
    actionFailure: ActionTypes.REQUEST_HOMEPAGE_TOPIC_PLAN,
    authenticated: true,
    actionProps: {
      topicId: topicId
    }
  })
}

function fetchHomepageEngagementNetwork (topicId) {
  return utils.makeApiCall({
    url: `/api/homepage/${topicId}/chart/metrics`,
    actionRequest: ActionTypes.REQUEST_HOMEPAGE_ENGAGEMENT_NETWORK,
    actionReceive: ActionTypes.RECEIVE_HOMEPAGE_ENGAGEMENT_NETWORK,
    actionFailure: ActionTypes.REQUEST_HOMEPAGE_ENGAGEMENT_NETWORK_FAILURE,
    authenticated: true,
    actionProps: {
      topicId: topicId
    }
  })
}


function fetchHomepageDemo (topicId) {
  return utils.makeApiCall({
    url: `/api/topics/${topicId}/plan/demographics`,
    actionRequest: ActionTypes.REQUEST_HOMEPAGE_DEMOGRAPHICS,
    actionReceive: ActionTypes.RECEIVE_HOMEPAGE_DEMOGRAPHICS,
    actionFailure: ActionTypes.REQUEST_HOMEPAGE_DEMOGRAPHICS_FAILURE,
    authenticated: true,
    actionProps: {
      topicId: topicId
    }
  })
}

function fetchHomepageWhatsNew (topicId, startDate, endDate) {
  const body = {
    start_date: startDate,
    end_date: endDate
  }
  return utils.makeApiCall({
    url: '/api/insights/calendar',
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_HOMEPAGE_WHATS_NEW,
    actionReceive: ActionTypes.RECEIVE_HOMEPAGE_WHATS_NEW,
    actionFailure: ActionTypes.REQUEST_HOMEPAGE_WHATS_NEW_FAILURE,
    authenticated: true,
    actionProps: {
      topicId: topicId
    }
  })
}

function fetchHomepageTopShows (topicId) {
  return utils.makeApiCall({
    url: '/api/external-public/reco/charts',
    actionRequest: ActionTypes.REQUEST_HOMEPAGE_TOP_SHOWS,
    actionReceive: ActionTypes.RECEIVE_HOMEPAGE_TOP_SHOWS,
    actionFailure: ActionTypes.REQUEST_HOMEPAGE_TOP_SHOWS_FAILURE,
    authenticated: true,
    actionProps: {
      topicId: topicId
    }
  })
}

function fetchHomepageTrendingVideos (topicId) {
  const body = {
    page: 1,
    filters: PlanFilters.Video,
    homepage: true
  }
  return utils.makeApiCall({
    url: `/api/topics/${topicId}/plan`,
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_HOMEPAGE_TRENDING_VIDEOS,
    actionReceive: ActionTypes.RECEIVE_HOMEPAGE_TRENDING_VIDEOS,
    actionFailure: ActionTypes.REQUEST_HOMEPAGE_TRENDING_VIDEOS_FAILURE,
    authenticated: true,
    actionProps: {
      topicId: topicId
    }
  })
}

function fetchHomepageAnticipatedShows (topicId) {
  const body = {
    page: 1,
    filters: PlanFilters.Anticipation
  }
  return utils.makeApiCall({
    url: `/api/topics/${topicId}/plan`,
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_HOMEPAGE_ANTICIPATED_SHOWS,
    actionReceive: ActionTypes.RECEIVE_HOMEPAGE_ANTICIPATED_SHOWS,
    actionFailure: ActionTypes.REQUEST_HOMEPAGE_ANTICIPATED_SHOWS_FAILURE,
    authenticated: true,
    actionProps: {
      topicId: topicId
    }
  })
}

// -----------------------------------------------------------------------------
// User invokable actions

export function fetchHomepageIfNeeded (groupName) {
  return (dispatch, getState) => {
    const state = (getState().homepage.list || {})
    if (utils.shouldFetch(state)) {
      return dispatch(fetchHomepage(groupName))
    }
    return Promise.resolve()
  }
}

export function fetchHomepageTopicDetailsIfNeeded (topicId) {
  return (dispatch, getState) => {
    const state = (getState().homepage.byId[topicId] || {}).homepageDetails
    if (utils.shouldFetch(state)) {
      return dispatch(fetchHomepageTopicDetails(topicId))
    }
    return Promise.resolve()
  }
}

export function fetchHomepageTopicPlanIfNeeded (topicId) {
  return (dispatch, getState) => {
    const state = (getState().homepage.byId[topicId] || {}).homepagePlan
    if (utils.shouldFetch(state)) {
      return dispatch(fetchHomepageTopicPlan(topicId))
    }
    return Promise.resolve()
  }
}

export function fetchHomepageDemoIfNeeded (topicId) {
  return (dispatch, getState) => {
    const state = (getState().homepage.byId[topicId] || {}).demographics
    if (utils.shouldFetch(state)) {
      return dispatch(fetchHomepageDemo(topicId))
    }
    return Promise.resolve()
  }
}

export function fetchHomepageEngagementNetworkIfNeeded (topicId) {
  return (dispatch, getState) => {
    const state = (getState().homepage.byId[topicId] || {}).engagementNetwork
    if (utils.shouldFetch(state)) {
      return dispatch(fetchHomepageEngagementNetwork(topicId))
    }
    return Promise.resolve()
  }
}

export function fetchHomepageWhatsNewIfNeeded (topicId, startDate, endDate) {
  return (dispatch, getState) => {
    const state = (getState().homepage.byId[topicId] || {}).whatsNew
    if (utils.shouldFetch(state)) {
      return dispatch(fetchHomepageWhatsNew(topicId, startDate, endDate))
    }
    return Promise.resolve()
  }
}

export function fetchHomepageTopShowsIfNeeded (topicId) {
  return (dispatch, getState) => {
    const state = (getState().homepage.byId[topicId] || {}).topShows
    if (utils.shouldFetch(state)) {
      return dispatch(fetchHomepageTopShows(topicId))
    }
    return Promise.resolve()
  }
}

export function fetchHomepageTrendingVideosIfNeeded (topicId) {
  return (dispatch, getState) => {
    const state = (getState().homepage.byId[topicId] || {}).trendingVideos
    if (utils.shouldFetch(state)) {
      return dispatch(fetchHomepageTrendingVideos(topicId))
    }
    return Promise.resolve()
  }
}

export function fetchHomepageAnticipatedShowsIfNeeded (topicId) {
  return (dispatch, getState) => {
    const state = (getState().homepage.byId[topicId] || {}).anticipatedShows
    if (utils.shouldFetch(state)) {
      return dispatch(fetchHomepageAnticipatedShows(topicId))
    }
    return Promise.resolve()
  }
}